import React from 'react';

const WireResultsContext = React.createContext();

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'setLoadingSimilar':
      return { ...state, loadingSimilar: payload };
    case 'setSimilarWires':
      return { ...state, similarWires: payload };
    case 'setOtherWires':
      return { ...state, otherWires: payload };
    case 'setKeywords':
      return { ...state, keywords: payload };
    case 'setStockCodes':
      return { ...state, stockCodes: payload };
    default:
      throw new Error();
  }
};

const defaultState = {
  loadingSimilar: null,
  similarWires: [],
  otherWires: [],
  keywords: [],
  stockCodes: [],
};

export default WireResultsContext;
export {
  reducer,
  defaultState,
};
